export { SlotOpenerEntryPoint } from './entrypoint';
export type { SlotOpenerApi } from './slotOpenerApi';
